import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ScopeProvider } from '../../../app/upgraded.providers';

@Directive({
  selector: 'app-job',
  providers: [ScopeProvider],
})
export class JobUpgradeDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('jobDirective', elementRef, injector);
  }
}
